export default __webpack_public_path__ + "static/media/snackKeto.18f003bc.svg";